"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray"),
    _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2),
    _extends2 = require("babel-runtime/helpers/extends"),
    _extends3 = _interopRequireDefault(_extends2),
    _keys = require("babel-runtime/core-js/object/keys"),
    _keys2 = _interopRequireDefault(_keys),
    _slicedToArray2 = require("babel-runtime/helpers/slicedToArray"),
    _slicedToArray3 = _interopRequireDefault(_slicedToArray2),
    _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _officeUiFabricReact = require("office-ui-fabric-react"),
    _MonthPagerLayout = require("../MonthPagerLayout"),
    _reactRedux = require("react-redux"),
    _index = require("./index"),
    _get = require("lodash/get"),
    _get2 = _interopRequireDefault(_get),
    _elements = require("../../elements"),
    _onRecordSave = require("./onRecordSave"),
    _useDbStore = require("./useDbStore"),
    _SingleItemEdit = require("./SingleItemEdit"),
    _useStorage = require("../../libs/useStorage");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var usePanel = function usePanel() {
  var a = (0, _react.useState)(!1),
      b = (0, _slicedToArray3.default)(a, 2),
      c = b[0],
      e = b[1],
      f = (0, _react.useState)(null),
      g = (0, _slicedToArray3.default)(f, 2),
      h = g[0],
      i = g[1];
  return {
    isPanelOpen: c,
    panelData: h,
    showPanel: function showPanel(a) {
      i(a), e(!0);
    },
    hidePanel: function hidePanel() {
      i(null), e(!1);
    }
  };
},
    Items = _react2.default.memo(function (a) {
  var b = a.navigate,
      c = (0, _react.useContext)(_index.ConfigContext),
      d = (0, _useDbStore.useDbStore)(c),
      e = usePanel(),
      f = e.isPanelOpen,
      g = e.panelData,
      h = e.showPanel,
      i = e.hidePanel,
      j = (0, _keys2.default)(c.pageOptions)[0],
      k = (0, _useStorage.useStateWithSessionStorage)(c.sessionKey + "key", j),
      l = (0, _slicedToArray3.default)(k, 2),
      m = l[0],
      n = l[1],
      o = (0, _get2.default)(c.pageOptions, [m], c.pageOptions[j]),
      p = o.pageSelector,
      q = o.pageDispatcher,
      r = q === void 0 ? null : q,
      s = (0, _reactRedux.useSelector)(o.optionsSelector),
      t = (0, _react.useCallback)(function (a) {
    return (0, _get2.default)(c, "renderItemCard") ? c.renderItemCard({
      item: a,
      EditItemButton: function EditItemButton(d) {
        var e = a[c.primaryKey],
            f = (0, _get2.default)(c, "panelForEditItem") ? {
          onClick: function a() {
            h({
              recPkInPanel: e
            });
          }
        } : !b ? {
          href: c.homeUrl().trim().replace(/\/$/, "") + "/" + e + "/edit"
        } : {
          onClick: function a() {
            return b(c.homeUrl().trim().replace(/\/$/, "") + "/" + e + "/edit");
          }
        };
        return "action" === (0, _get2.default)(c, "editBtnType") ? _react2.default.createElement(_officeUiFabricReact.ActionButton, (0, _extends3.default)({}, d, {
          iconProps: {
            iconName: "Edit"
          },
          text: c.editBtnText
        }, f)) : _react2.default.createElement(_officeUiFabricReact.DefaultButton, (0, _extends3.default)({}, d, {
          iconProps: {
            iconName: "Edit"
          },
          text: c.editBtnText
        }, f));
      },
      onSave: function h(b) {
        var e = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : function () {},
            f = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : alert,
            g = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : {};
        return (0, _onRecordSave.onRecordSave)({
          data: b,
          success_callback: e,
          failure_callback: f,
          Config: c,
          dbStore: d,
          values: a,
          metaParams: g
        });
      },
      Config: c,
      key: a[c.primaryKey],
      setRenderInPanel: function b(a) {
        return !a ? i() : h({
          renderInPanel: a
        });
      }
    }) : null;
  }, [c]),
      u = []; // const [sKey, setSKey] = useState(
  //   zkey
  // );

  1 < (0, _keys2.default)(c.pageOptions).length && (u = [{
    key: "pageKeys",
    text: m,
    iconProps: {
      iconName: "TableGroup"
    },
    subMenuProps: {
      items: (0, _keys2.default)(c.pageOptions).map(function (a) {
        return {
          key: a,
          text: a
        };
      }),
      onItemClick: function c(a, b) {
        return n(b.key);
      }
    }
  }]);
  var v = c.colDefns,
      w = c.displayAsTable,
      x = c.showTableHeader,
      y = c.excelColDefns,
      z = c.filterProps,
      A = c.tableEditButtonProps,
      B = c.tableDeleteButtonProps,
      C = (0, _react.useCallback)(function (a) {
    if (!A && !B) return null;
    var e = a[c.primaryKey],
        f = (0, _get2.default)(c, "panelForEditItem") ? {
      onClick: function a() {
        h({
          recPkInPanel: e
        });
      }
    } : !b ? {
      href: c.homeUrl().trim().replace(/\/$/, "") + "/" + e + "/edit"
    } : {
      onClick: function a() {
        return b(c.homeUrl().trim().replace(/\/$/, "") + "/" + e + "/edit");
      }
    };
    return _react2.default.createElement(_react2.default.Fragment, null, A && _react2.default.createElement(_officeUiFabricReact.ActionButton, (0, _extends3.default)({
      iconProps: {
        iconName: "Edit"
      }
    }, A, f)), B && _react2.default.createElement(_elements.ConfirmButton, {
      onClick: function e() {
        var b = a[c.primaryKey];
        d.delete(c.collection, b);
      },
      alert: {
        title: "Deleting this Record",
        message: "Are you sure?"
      }
    }, _react2.default.createElement(_officeUiFabricReact.ActionButton, (0, _extends3.default)({
      iconProps: {
        iconName: "Delete"
      }
    }, B))));
  }, []),
      D = (0, _react.useMemo)(function () {
    return {
      tableOnSave: function b(a) {
        return function (b) {
          var e = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : function () {},
              f = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : alert;
          return (0, _onRecordSave.onRecordSave)({
            data: b,
            success_callback: e,
            failure_callback: f,
            Config: c,
            dbStore: d,
            values: a
          });
        };
      },
      Config: c,
      setRenderInPanel: function b(a) {
        return !a ? i() : h({
          renderInPanel: a
        });
      }
    };
  }, [c]),
      E = (0, _react.useState)((0, _get2.default)(c, "panelForNewItem") ? {
    onClick: function a() {
      h({
        recPkInPanel: null
      });
    }
  } : !b ? {
    href: c.homeUrl().trim().replace(/\/$/, "") + "/new"
  } : {
    onClick: function a() {
      return b(c.homeUrl().trim().replace(/\/$/, "") + "/new");
    }
  }),
      F = (0, _slicedToArray3.default)(E, 1),
      G = F[0];
  return _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_MonthPagerLayout.JustPagerLayout, {
    justSessionKey: c.sessionKey + m,
    justSelector: p,
    justDispatcher: r,
    justOptions: s,
    noItemMsg: c.noItemMsg,
    mainTitle: c.mainTitle,
    mainTitleIcon: c.mainTitleIcon,
    renderItem: t,
    colDefns: v,
    displayAsTable: w,
    showTableHeader: x,
    tableUDButtons: A || B ? C : null,
    passConfig: D,
    excelColDefns: y,
    filterProps: z,
    commandBarProps: (0, _extends3.default)({
      farItems: [].concat((0, _toConsumableArray3.default)(u), (0, _toConsumableArray3.default)("newBtnText" in c && !!c.newBtnText ? [(0, _extends3.default)({
        key: "newItem",
        text: c.newBtnText,
        iconProps: {
          iconName: (0, _get2.default)(c, "newBtnIcon", "AddFriend")
        }
      }, "enableBulkUpload" in c && c.enableBulkUpload ? {
        subMenuProps: {
          items: [(0, _extends3.default)({
            key: "newItemS",
            text: "New Entry",
            iconProps: {
              iconName: "Add"
            }
          }, G)].concat((0, _toConsumableArray3.default)("enableBulkUpload" in c && c.enableBulkUpload ? [(0, _extends3.default)({
            key: "bulkUpload",
            text: "Bulk Upload",
            iconProps: {
              iconName: "Upload"
            }
          }, !b ? {
            href: c.homeUrl().trim().replace(/\/$/, "") + "/bulk-upload"
          } : {
            onClick: function a() {
              return b(c.homeUrl().trim().replace(/\/$/, "") + "/bulk-upload");
            }
          })] : []))
        }
      } : G)] : []))
    }, "function" == typeof c.backUrl ? {
      overflowItems: [(0, _extends3.default)({
        key: "fhome",
        text: "Home",
        iconProps: {
          iconName: "Home"
        }
      }, !b ? {
        href: c.backUrl()
      } : {
        onClick: function a() {
          return b(c.backUrl());
        }
      })]
    } : {})
  }), _react2.default.createElement(_officeUiFabricReact.Panel, (0, _extends3.default)({
    type: _officeUiFabricReact.PanelType.medium,
    styles: {
      main: {
        backgroundColor: "white"
      },
      overlay: {
        backgroundColor: "rgba(0,0,0, 0.7)"
      }
    }
  }, c.panelProps, {
    isOpen: f,
    onDismiss: i
  }), !!g && "recPkInPanel" in g && _react2.default.createElement(_SingleItemEdit.MainForPanel, {
    pk_val: g.recPkInPanel,
    goBack: i
  }), !!g && "renderInPanel" in g && g.renderInPanel));
});

exports.default = Items;